<script>
import Service from '../../services/vessel-protocol';
import config from '../../common/genericPanelConf';

import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
import GenericDataTable from '../../components/generic/GenericDataTable.vue';
// import GenericCustomAutocompleteV2 from '../../components/generic/GenericCustomAutocompleteV2.vue'


export default{
  components: {
    ResponsiveButton
    ,GenericDataTable
    // GenericCustomAutocompleteV2
  },
  data(){
    return {
      configurationCharge: {},
      configurationDischarge: {},
      filters: {
        dateFrom: Utils.formatDatePlusMonths(new Date(), -1),
        dateTo: Utils.formatDatePlusDays(new Date(), 0)
      }
    }
  },
  
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    },
  },
  created(){
     this.configurationCharge = {...config.getConfiguration('VesselProtocolReportLoading')};
     this.configurationDischarge = {...config.getConfiguration('VesselProtocolReportDischarge')};
  },
  mounted(){
    this.$store.dispatch('security/setNavbarTitle', 'vesselProtocolProtocolReport');
  },
  watch: {

  },
  methods: {
    loadData(){
      this.loadCharge();
      this.loadDischarge();
    },
    loadCharge(){
      let filters = {
        dateFrom : Utils.formatDateForAPI(this.filters.dateFrom),
        dateTo : Utils.formatDateForAPI(this.filters.dateTo)
      }
      this.$refs.protocolReportCharge.filterFromView(filters, true);
    },
    loadDischarge(){
     let filters = {
        dateFrom : Utils.formatDateForAPI(this.filters.dateFrom),
        dateTo : Utils.formatDateForAPI(this.filters.dateTo)
      }
      this.$refs.protocolReportDischarge.filterFromView(filters, true);
    },
    printReport(reportType){
      if(reportType == 'DISCHARGE'){
        this.$store.dispatch("generic/setLoading", true);

        Service.printDischargeSimWeb(this.filters, ({success, data, message}) => {
            this.$store.dispatch("generic/setLoading", false);
            
            if(success){
                var fileURL = window.URL.createObjectURL(new Blob([data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'ReportProtocolli.xlsx');
                document.body.appendChild(fileLink);
            
                fileLink.click();
            } else{
              this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
            }
        })
      }else if(reportType== 'LOADING'){
        this.$store.dispatch("generic/setLoading", true);

        Service.printLoadingSimWeb(this.filters, ({success, data, message}) => {
            this.$store.dispatch("generic/setLoading", false);
            
            if(success){
                var fileURL = window.URL.createObjectURL(new Blob([data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'ReportProtocolli.xlsx');
                document.body.appendChild(fileLink);
            
                fileLink.click();
            } else{
              this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
            }
        })
      }
    }
  }
}

</script>

<template>
  <main>
    <div class="grid">
      <div class="col-12 lg:col-2 field">
        <label for="from">{{$t('from')}}</label>
        <Calendar
            :class="{'p-inputtext-sm w-full': true}"
            :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
            :dateFormat="constants.DATE_FORMAT_POINT"
            :showTime="false"
            v-model="filters.dateFrom"
            :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
    </div>
    <div class="col-12 lg:col-2 field">
        <label for="to">{{$t('to')}}</label>
        <Calendar
            :class="{'p-inputtext-sm w-full': true}"
            :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
            :dateFormat="constants.DATE_FORMAT_POINT"
            :showTime="false"
            v-model="filters.dateTo"
            :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
    </div>
    <!-- <div class="col-12 lg:col-2 field">
      <label for="type" >{{ $t('type') }}</label>
      <Dropdown :options="types" optionValue="value" optionLabel="label" v-model="reportType"
        class="w-full p-inputtext-sm" />
    </div> -->
     <div class="col-12 lg:col-4 my-4">
        <ResponsiveButton :label="$t('btn.load')" icon="pi pi-replay" class="mx-1 my-1" @click="loadData"/>   
     </div>

      <div class="col-12" style="height: calc(80vh)">
        <TabView >
          <TabPanel :header="$t('Caricazioni')">
              <div class="col-12" style="height: calc(75vh)">
                  <ResponsiveButton :label="$t('tankOperations.btn.export')" icon="pi pi-file" class="p-button-sm p-button-outlined m-1" @click="printReport('LOADING')"/>
                  <GenericDataTable :configuration="configurationCharge" :category="'vessel-protocol'" :name="'protocol-report-charge'" ref="protocolReportCharge"/>
              </div>
          </TabPanel>
          <TabPanel :header="$t('Discariche')">
              <div class="col-12" style="height: calc(75vh)">
                  <ResponsiveButton :label="$t('tankOperations.btn.export')" icon="pi pi-file" class="p-button-sm p-button-outlined m-1" @click="printReport('DISCHARGE')"/>
                  <GenericDataTable :configuration="configurationDischarge" :category="'vessel-protocol'" :name="'protocol-report-discharge'" ref="protocolReportDischarge" />
              </div>
          </TabPanel>
      </TabView>
      </div>
    </div>
  </main>
</template>
